const contentIds = {
	'test': 1,
	'birthday-and-city': 2
};

const defaultLocale = {
	'test': 'test content (use only for testing)',
	'birthday-and-city': 'filling in birthday and city'
};

const locale = {
	ru: defaultLocale,
	uk: defaultLocale,
	en: defaultLocale,
	de: defaultLocale,
	vi: defaultLocale,
	th: defaultLocale
};

module.exports = {
	enum: contentIds,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/popup-custom-content-ids.js